<template>
  <v-container fluid align-start ma-0 pa-2 class="epmsZ000-main container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical
          :headerTitle="menuTitle"
          :useBtnList="useBtnList1"
          :customBtnList="customBtnList1"
          @btnFilesControl="btnFilesControl()"
        >
          <template v-slot:body>
            <v-row no-gutters>
              <v-col cols="12">
                <DxDataGrid
                  :ref="noticeRef"
                  :data-source="noticeList" 
                  :remote-operations="false" 
                  :hover-state-enabled="true"
                  :allow-column-resizing="true" 
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true" 
                  :show-borders="true" 
                  :width="grid.width"
                  :show-row-lines="true" 
                  key-expr="id" 
                  :focused-row-enabled="true"
                  :column-hiding-enabled="false" 
                  :selection="{ mode: 'none' }"
                  @rowClick="noticeRowClick"
                >
                  <DxPager :show-page-size-selector="false"/>
                  <DxPaging :page-size="10" />
                  <DxColumn data-field="bulletinNo" caption="Notice No" width="13%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="title" caption="Title" width="61%" data-type="string" alignment="left" :allow-editing="false" />
                  <DxColumn data-field="stDte" caption="From" width="13%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="fiDte" caption="Until" width="13%" data-type="string" alignment="center" :allow-editing="false" />
                </DxDataGrid>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col>
                <i-card-top
                  class="d-md-flex"
                  outlined
                  :useBtnList="useBtnList2"
                  :unUseBtnList="unUseBtnList2"
                  :customBtnList="customBtnList2"
                  :btnKey="useBtnList2Key"
                  @btnNew="btnNew"
                  @btnModify="btnModify"
                  @btnDelete="btnDelete"
                  @btnSave="btnSave"
                >
                  <template v-slot:body>
                    <v-row no-gutters>
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>

            <v-row no-gutters class="pt-1 pb-2">
              <v-col>
                <v-row dense class="form-layout">
                  <v-col cols="12" class="pa-0">
                    <v-row no-gutters>
                      <v-col cols="1" class="pa-2 d-flex justify-end align-center formHeader">
                        Notice No
                      </v-col>
                      <v-col cols="2" class="pa-2 d-flex align-center">
                        <v-text-field 
                          class="text-center"
                          v-model="bulletinNo" 
                          dense 
                          outlined 
                          hide-details="auto"
                          readonly
                        />
                      </v-col>

                      <v-col cols="1" class="pa-2 d-flex justify-end align-center formHeader">
                        Period
                      </v-col>
                      <v-col cols="8" class="pa-2 d-flex align-center">
                        <DxDateBox
                          :value="stDte"
                          width="125px"
                          height="30px"
                          display-format="yyyy-MM-dd"
                          :acceptCustomValue="false"
                          @value-changed="e => {stDte = e.value && getStrFormat(e.value)}"
                        />
                      <span class="px-2 d-flex align-center text-h6"> ~ </span>
                        <DxDateBox
                          :value="fiDte"
                          width="125px"
                          height="30px"
                          display-format="yyyy-MM-dd"
                          :acceptCustomValue="false"
                          @value-changed="e => {fiDte = e.value && getStrFormat(e.value)}"
                        />
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col cols="1" class="pa-2 d-flex justify-end align-center formHeader">
                        Title
                      </v-col>
                      <v-col cols="11" class="pa-2 d-flex align-center">
                        <v-text-field 
                          v-model="title" 
                          dense 
                          outlined 
                          hide-details="auto"
                        />
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col cols="1" class="pa-2 d-flex justify-end align-start formHeader">
                        Content
                      </v-col>
                      <v-col cols="11" class="pa-2 d-flex align-center">
                        <htmlEditor class="w-full" :value="content" @text-change="content = $event" />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>

    <epmsZ005 :showEpmsZ005.sync="showEpmsZ005" />
  </v-container>
</template>

<script>
import baseview from '@/components/base/baseview'
import BaseDataGrid from '@/components/base/BaseDataGrid'
import DxDateBox from 'devextreme-vue/date-box'
import notify from 'devextreme/ui/notify'
import { getNoticeList, getContents, epmsZ000Save, epmsZ000Delete } from '@/api/view/hip/Z/epmsZ000'
import { getDateFormat, getCurrentDate, getLastDate, trim } from '@/utils/common.js'
import htmlEditor from '@/components/editor/htmlEditor'
import epmsZ005 from '@/views/hip/Z/popup/epmsZ005'

export default {
  name: 'epmsZ000',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxDateBox,
    htmlEditor,
    epmsZ005
  },
  data() {
     return {
       menuTitle: this.$route.meta.title,
       userId: this.$store.state.user.userId,
       noticeRef: 'noticeRef',
       noticeList: [],
       selectedNotice: null,
       bulletinNo: '',
       stDte: '',
       fiDte: '',
       title: '',
       content: '',
       useBtnList1: ['btnFilesControl'],
       useBtnList2: ['btnNew', 'btnModify', 'btnDelete', 'btnSave'],
       unUseBtnList2: ['btnModify', 'btnDelete'],
       customBtnList1: [{ id: 'btnFilesControl', text: 'Files Control', icon: 'file_up_down' }],
       customBtnList2: [{ id: 'btnModify', text: 'Modify', icon: 'save' }],
       useBtnList2Key: 0,
       showEpmsZ005: false
     }
  },
  computed: {
    noticeInstance() {
      return this.GetDataGrid(this.noticeRef)
    }
  },
  methods: {
    init() {
      this.noticeInstance.option('defaultPaging', false)

      this.retrieve()
    },
    clearData() {
      this.noticeList = []
      this.selectedNotice = null
      this.noticeInstance.clearSelection()
      this.bulletinNo = ''
      this.stDte = ''
      this.fiDte = ''
      this.title = ''
      this.content = ''
      this.unUseBtnList2 = ['btnModify', 'btnDelete']
      this.useBtnList2Key++
    },
    async retrieve() {
      this.openLoading()
      this.clearData()
      
      await getNoticeList().then(res => {
        // console.log('res', res)

        this.noticeList = res.list
      }).finally(() => {
        this.endLoading()
      })
    },
    noticeRowClick(e) {
      if (e.rowIndex >= 0) {
        if (e.data) {
          this.selectedNotice = e.data
        } else {
          this.selectedNotice = null
        }

        // console.log('this.selectedNotice', this.selectedNotice)
        
        this.getContent()
      }
    },
    disableContent(disable) {
      if(disable) {
        document.getElementsByClassName('ql-toolbar')[0].style.display = 'none'
        document.getElementById('quill-container').style['border-top'] = '1px solid #ccc'
        document.getElementsByClassName('ql-editor')[0].setAttribute('contenteditable',  false)
      } else {
        document.getElementsByClassName('ql-toolbar')[0].style.display = ''
        document.getElementById('quill-container').style['border-top'] = '0'
        document.getElementsByClassName('ql-editor')[0].setAttribute('contenteditable',  true)
      }
    },
    async getContent() {
      this.bulletinNo = this.selectedNotice.bulletinNo
      this.stDte = this.selectedNotice.stDte
      this.fiDte = this.selectedNotice.fiDte
      this.title = this.selectedNotice.title
      this.content = ''

      this.setBtns('save')
      this.disableContent(true)

      this.openLoading()
      getContents(
        // `http://ebiz.hvs.com.vn/attachfile/epms/notice/hip_notice_${this.bulletinNo}.html`
        `/attachfile/epms/notice/hip_notice_${this.bulletinNo}.html`
      ).then(res => {
        // console.log('res', res)

        this.content = res.body
      }).catch(err => {
        // console.log('err', err)
        // this.content = ''
        this.vToastify(this.$t('Failed to content download'), 'warn')
      }).finally(() => {
        this.endLoading()
      })
    },

    setBtns(gbn) {
      switch(gbn) {
        case 'new':
          this.unUseBtnList2 = ['btnModify', 'btnDelete']
          this.useBtnList2Key++
          break;
        case 'mod':
          this.unUseBtnList2 = ['btnModify']
          this.useBtnList2Key++
          break;
        case 'save':
          this.unUseBtnList2 = ['btnSave']
          this.useBtnList2Key++
          break;
      }
    },
    btnFilesControl() {
      this.showEpmsZ005 = true
    },
    btnNew() {
      this.setBtns('new')

      this.bulletinNo = ''
      this.title = ''
      this.content = 'Make Notice...'
      this.stDte = getCurrentDate()
      this.fiDte = getLastDate()

      this.disableContent(false)
    },
    btnModify() {
      this.setBtns('mod')
      this.disableContent(false)
    },
    btnDelete() {
      if(!this.bulletinNo) {
        this.vToastify(this.$t('Notice No is not found.'), 'warn')
        return
      }

      this.vToastifyPrompt(
        this.$t('Do you want to delete the notice?'),
        'info',
        async current => {
          this.openLoading()

          const param = {
            bulletinNo: this.bulletinNo
          }

          epmsZ000Delete(param).then(res => {
            const msg = res.body
            if(msg === 'OK') {
              notify(this.$t('Delete is completed.'), 'success', 3000)
              
              this.retrieve()
            } else {
              this.vToastify(this.$t(msg), 'warn')
            }
          }).finally(() => {
            this.endLoading()
          })
        },
        null,
        true
      )
    },
    btnSave() {
      let cont = trim(this.content)

      if(!this.stDte) {
        this.vToastify(this.$t('Select start date.'), 'warn')
        return
      }

      if(!this.fiDte) {
        this.vToastify(this.$t('Select finish date.'), 'warn')
        return
      }

      if(!this.title) {
        this.vToastify(this.$t('Input title.'), 'warn')
        return
      }

      if(!cont) {
        this.vToastify(this.$t('Input content.'), 'warn')
        return
      }

      // cont = encodeURIComponent(cont)

      const param = {
        bulletinNo: this.bulletinNo,
        stDte: this.stDte,
        fiDte: this.fiDte,
        title: this.title,
        content: cont,
        userId: this.userId
      }

      this.openLoading()
      epmsZ000Save(param).then(res => {
        const msg = res.body
        if(msg === 'OK') {
          notify(this.$t('Save is completed.'), 'success', 3000)
          
          this.retrieve()
        } else {
          this.vToastify(this.$t(msg), 'warn')
        }
      }).finally(() => {
        this.endLoading()
      })
    },
    getStrFormat(date) {
      return getDateFormat(date)
    }
  },
  mounted() {
    this.init()

    
  }
}
</script>

<style lang="scss" scoped>
.epmsZ000-main {
  .form-layout::v-deep .col {
    border-width: 1px 0 0 1px;
    border-style: solid;
    border-color: gray;
    
    .row {
      border-width: 0 0 1px 0 !important;
      border-style: solid !important;
      border-color: gray !important;
    }

    .col {
      border-width: 0 1px 0 0 !important;
      border-style: solid !important;
      border-color: gray !important;
    }
  }

  .formHeader {
    background-color: rgb(223, 227, 213);
    font-weight: bold;
    // border: 1px solid gray;
    color: black;
    font-size: 9pt;
  }
}
</style>